import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {MonkeysGoldAllReelsFilledWinView} from "./MonkeysGoldAllReelsFilledWinView";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";

/**
 * Created by Jerker Nord on 2020-06-24.
 */

export class MonkeysGoldAllReelsFilledWinController extends WinPresentationController {

    private _view:MonkeysGoldAllReelsFilledWinView
    private _winAmount:number;
    private _nextMode:string;
    private _allWinPositions:boolean[][];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "MonkeysGoldAllReelsFilledWinController", skippable : false});
        this._view = MonkeysGoldGameModuleConfig.monkeysGoldAllReelsFilledWinView = new MonkeysGoldAllReelsFilledWinView();
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._nextMode = data.nextMode;
        this._winAmount = data.singleWin;
        this._allWinPositions = data.allWinPositions;
    }

    protected hasWin():boolean {
        for(let i:number = 0; i < this._allWinPositions.length; i++) {
            for(let j:number = 0; j < this._allWinPositions[i].length; j++) {
                if(this._allWinPositions[i][j] == false) {
                    return false;
                }
            }
        }
        return true;
    }

    //Do some cleanup if we have an all reel win situation
    protected startWinPresentation():void {
        MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.endBottomFire();
        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {

    }
}